import { render, staticRenderFns } from "./NewScorecard.vue?vue&type=template&id=940e7744&scoped=true&"
import script from "./NewScorecard.vue?vue&type=script&lang=js&"
export * from "./NewScorecard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940e7744",
  null
  
)

export default component.exports